import { Component, OnInit, OnDestroy } from '@angular/core';
import { TourService } from './tour.service';
import { UserService } from '../../services/core.user.service';
import { NotificationService } from '../../services/core.notification.service';

@Component({
    selector: 'gf-tour-button',
    template: require('./tour.html')
})
export class TourButtonComponent implements OnInit, OnDestroy {

	public hasTour;
	public hasUser;
	public tourName;

    constructor(
		private tourService: TourService,
		private userService: UserService,
		private notificationService: NotificationService
	) { 
		this.notificationService.subscribe(
			'tour-widget', 'tour', () => {
				this.hasTour = this.tourService.hasTour();
				this.tourName = this.tourService.getTour();
			}
		);
	}

	runTour() {
		if (this.hasTour) {
			this.tourService.runTour();
		}
	}
    
    ngOnInit() {
		this.hasUser = this.userService.hasUser();
		this.hasTour = this.tourService.hasTour();
	}

	ngOnDestroy() {
		this.notificationService.unsubscribe('tour-widget');
	}
}